import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ComplaintTypeService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/ComplaintType",
      top: "1",
      filter: `Code eq '${code}'`,
      select: ["RecordId", "Code", "Description", "SortOrder", "IsDefault", "Inactive", "DateCreated", "CreatedBy", "DateChanged", "ChangedBy"],
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async save(mode, payload, recordId) {
    if (mode === "create") {
      return await ApiService.post("api/ComplaintType", payload, "Guid");
    } else {
      return await ApiService.patch("api/ComplaintType", `guid'${recordId}'`, payload, "String");
    }
  },

  async saveDefault(recordId) {
    var url = "api/ComplaintType/SaveDefault";
    return await ApiService.post(url, { RecordId: recordId }, "Guid");
  },

  async getAll() {
    return await ApiService.get(
      "api/ComplaintType?$orderby=SortOrder asc&$select=Code,Description,IsDefault"
    );
  },

  dataSourceConfig(params) {
    return ApiService.createDataSource("api/ComplaintType", params);
  },
};

export { ComplaintTypeService };
